import styles from './SolutionsWhoFor.module.css'

const audiences = [
  'Growing businesses outgrowing spreadsheets and manual processes.',
  'Teams juggling disconnected tools and scattered data that should work together.',
  'Leaders who want AI delivering real time savings inside their business.',
  'Companies ready to free up time and mental energy currently spent working around their own systems.',
]

const SolutionsWhoFor = () => {
  return (
    <section id="who-this-is-for-business" className={styles.section}>
      <div className="container">
        <div className={styles.layout}>
          <div className={styles.labelColumn}>
            <div className={styles.sectionTag}>
              <span className={styles.tagNumber}>03</span>
              <span className={styles.tagLine} />
              <span className={styles.tagText}>Who This Is For</span>
            </div>
          </div>

          <div className={styles.contentColumn}>
            <p className={styles.openingStatement}>
              This is for businesses ready to fix what is holding them back and get that time back.
            </p>

            <ul className={styles.list}>
              {audiences.map((item, i) => (
                <li key={i} className={styles.listItem}>
                  <span className={styles.tick}>✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SolutionsWhoFor
